/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface VoiceAgentInferencerTestOk
 */
export interface VoiceAgentInferencerTestOk {
  /**
   *
   * @type {boolean}
   * @memberof VoiceAgentInferencerTestOk
   */
  success: boolean;
}

/**
 * Check if a given object implements the VoiceAgentInferencerTestOk interface.
 */
export function instanceOfVoiceAgentInferencerTestOk(value: object): value is VoiceAgentInferencerTestOk {
  if (!('success' in value) || value['success'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerTestOkFromJSON(json: any): VoiceAgentInferencerTestOk {
  return VoiceAgentInferencerTestOkFromJSONTyped(json, false);
}

export function VoiceAgentInferencerTestOkFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerTestOk {
  if (json == null) {
    return json;
  }
  return {
    success: json['success'],
  };
}

export function VoiceAgentInferencerTestOkToJSON(value?: VoiceAgentInferencerTestOk | null): any {
  if (value == null) {
    return value;
  }
  return {
    success: value['success'],
  };
}
